import type { VideoPlannerState } from './video-planner-slice';
import type { VideoPlanWithCreationInfo } from './video-planner-types';

import type { RootState } from 'js/src/libs/RootState';

export const selectVideoPlannerState = (state: RootState): VideoPlannerState => state.videoPlanner;

export const selectVideoPlans = (state: RootState): VideoPlanWithCreationInfo[] =>
    selectVideoPlannerState(state).videoPlans;

export function getVideoPlanById(
    state: RootState,
    id: string,
): VideoPlanWithCreationInfo | undefined {
    return selectVideoPlans(state).find((plan) => plan.id === id);
}

export function getVideoPlans(state: RootState): VideoPlanWithCreationInfo[] {
    return selectVideoPlans(state);
}

export const selectSelectedVideoPlan = (state: RootState): string | null =>
    selectVideoPlannerState(state).selectedVideoPlan;

export const selectLuminaryInstanceForPlan = (state: RootState, planId: string) => {
    const plan = getVideoPlanById(state, planId);
    return plan?.luminaryInstance ?? null;
};

export const selectLuminaryInstanceLoadedForPlan = (state: RootState, planId: string): boolean => {
    const plan = getVideoPlanById(state, planId);
    return plan?.luminaryInstanceLoaded ?? false;
};
